module.exports = __webpack_public_path__ + "media/images/logo_sm-c30084ecc02e48c35ad4ae11dffa4b51.png";